/* sg-bestsellers: carrusel con indicador de página y contador de las tarjetas con estrella. */
if (!customElements.get('sg-bestsellers')) {
  class SgBestsellers extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sg-bs-track]');
      this.prev = this.querySelector('[data-sg-bs-prev]');
      this.next = this.querySelector('[data-sg-bs-next]');
      this.dots = this.querySelector('[data-sg-bs-dots]');
      this.current = this.querySelector('[data-sg-bs-current]');
      this.total = this.querySelector('[data-sg-bs-total]');
      this.pages = 1;

      this.prev.addEventListener('click', () => this.go(-1));
      this.next.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.build());
      this.resizeObserver.observe(this.track);
      this.build();

      this.end = this.dataset.end ? Date.parse(this.dataset.end) : NaN;
      this.skew = this.dataset.serverNow ? Number(this.dataset.serverNow) * 1000 - Date.now() : 0;
      this.startCountdown();
      this.initFilters();
    }

    startCountdown() {
      clearInterval(this.timer);
      this.tiles = this.querySelectorAll('[data-sg-cd]');
      if (this.tiles.length && !Number.isNaN(this.end)) {
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
    }

    /* Filtros por categoría: cada uno trae los más vendidos de su colección (vista ?view=bs-cards) y cambia el carrusel sin recargar la página.
       El primero («Recomendado») vuelve a los productos elegidos a mano. Las categorías ya vistas se guardan para no pedirlas otra vez. */
    initFilters() {
      this.chipsBox = this.querySelector('[data-sg-bs-chips]');
      this.list = this.querySelector('.sg-bs__list');
      if (!this.chipsBox || !this.list) return;
      this.home = this.list.innerHTML;
      this.cache = new Map();
      this.chips = [...this.chipsBox.querySelectorAll('[data-sg-bs-chip]')];
      this.chipsNext = this.querySelector('[data-sg-bs-chips-next]');
      this.allBtn = this.querySelector('.sg-bs__all-btn');
      this.allText = this.allBtn ? this.allBtn.querySelector('span') : null;
      this.allHome = this.allBtn ? { href: this.allBtn.getAttribute('href'), text: this.allText ? this.allText.textContent : '' } : null;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      this.chips.forEach((chip) => chip.addEventListener('click', async () => {
        if (chip.classList.contains('is-on')) return;
        this.chips.forEach((c) => { const on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', String(on)); });
        const handle = chip.dataset.sgBsChip;
        const ticket = ((this.ticket || 0) + 1);
        this.ticket = ticket;
        let html = this.home;
        if (handle) {
          html = this.cache.get(handle);
          if (!html) {
            this.track.classList.add('is-loading');
            try {
              const res = await fetch(`${root}collections/${encodeURIComponent(handle)}?sort_by=best-selling&view=bs-cards`);
              html = res.ok ? (await res.text()).trim() : '';
            } catch (err) { html = ''; }
            this.track.classList.remove('is-loading');
            if (html) this.cache.set(handle, html);
          }
        }
        if (this.ticket !== ticket) return; // se tocó otro filtro mientras cargaba
        if (!html) { this.list.innerHTML = this.home; this.chips[0].click(); return; }
        this.list.innerHTML = html;
        /* «Ver todos» lleva a la categoría elegida */
        if (this.allBtn && this.allHome) {
          this.allBtn.setAttribute('href', handle ? `${root}collections/${handle}` : this.allHome.href);
          if (this.allText) this.allText.textContent = handle ? `Ver todo ${chip.textContent.trim()}` : this.allHome.text;
        }
        this.track.scrollTo({ left: 0 });
        this.build();
        this.startCountdown();
      }));

      /* flecha que aparece cuando hay más filtros fuera de la vista */
      const edge = () => {
        const more = this.chipsBox.scrollWidth - this.chipsBox.clientWidth - this.chipsBox.scrollLeft > 4;
        if (this.chipsNext) this.chipsNext.hidden = !more;
        this.chipsBox.parentElement.classList.toggle('has-more', more);
      };
      this.chipsBox.addEventListener('scroll', edge, { passive: true });
      window.addEventListener('resize', edge);
      if (this.chipsNext) this.chipsNext.addEventListener('click', () => this.chipsBox.scrollBy({ left: this.chipsBox.clientWidth * 0.7, behavior: 'smooth' }));
      edge();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    get step() {
      return this.track.clientWidth * 0.9;
    }

    go(direction) {
      this.track.scrollBy({ left: direction * this.step, behavior: 'smooth' });
    }

    build() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.pages = max <= 4 ? 1 : Math.ceil(max / this.step) + 1;
      this.total.textContent = String(this.pages).padStart(2, '0');
      this.dots.replaceChildren();
      for (let i = 0; i < this.pages; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sg-bs__dot';
        dot.setAttribute('aria-label', `${this.dataset.pageLabel} ${i + 1}`);
        dot.addEventListener('click', () => this.track.scrollTo({ left: i * this.step, behavior: 'smooth' }));
        this.dots.append(dot);
      }
      this.update();
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const page = max <= 4 ? 0 : Math.min(this.pages - 1, Math.round(this.track.scrollLeft / this.step));
      this.current.textContent = String(page + 1).padStart(2, '0');
      [...this.dots.children].forEach((d, i) => d.setAttribute('aria-current', String(i === page)));
      this.prev.disabled = this.track.scrollLeft <= 4;
      this.next.disabled = this.track.scrollLeft >= max - 4;
    }

    tick() {
      const total = Math.max(0, Math.floor((this.end - (Date.now() + this.skew)) / 1000));
      const parts = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };
      this.tiles.forEach((tile) => {
        const text = String(parts[tile.dataset.sgCd]).padStart(2, '0');
        const num = tile.querySelector('.sg-cd__num');
        if (num.textContent === text) return;
        const first = !tile.dataset.ready;
        num.textContent = text;
        tile.dataset.ready = 'true';
        if (first) return;
        tile.classList.remove('is-tick');
        void tile.offsetWidth;
        tile.classList.add('is-tick');
      });
      if (total === 0) clearInterval(this.timer);
    }
  }

  customElements.define('sg-bestsellers', SgBestsellers);
}

/* Indicador deslizante de los filtros: sigue al chip activo. Solo reacciona a clics y a cambios de tamaño
   (sin observar el DOM) para no interferir con la lógica del carrusel. */
(() => {
  const setup = (box) => {
    const ind = box.querySelector('.sg-bs__ind');
    if (!ind || box.dataset.indReady) return;
    box.dataset.indReady = '1';
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const active = () => box.querySelector('.sg-bs__chip.is-on');
    const move = () => {
      const on = active();
      if (!on || !on.offsetWidth) return;
      ind.style.width = on.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + on.offsetLeft + 'px)';
      if (!box.classList.contains('is-ready')) box.classList.add('is-ready');
    };
    const center = () => {
      const on = active();
      if (!on || box.scrollWidth <= box.clientWidth) return;
      box.scrollTo({ left: on.offsetLeft - (box.clientWidth - on.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
    };
    box.addEventListener('click', (ev) => {
      if (!ev.target.closest('.sg-bs__chip')) return;
      requestAnimationFrame(() => { move(); center(); });
    });
    window.addEventListener('resize', move);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(move);
    move();
  };
  const start = () => document.querySelectorAll('[data-sg-bs-chips]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
